import React from 'react';

// Styles
import './EnterNow.css';

export default function EnterNow() {
  return (
    <div id="enterNow">
      <div className="container">
        <h1 className="title">Olá, entre e saiba tudo sobre o consignado<br/>privado Monee. Vamos lá?</h1>
        <div className="options-content">
          <div className="option">
            <div className="header">
              <h5 className="subtitle">Não sou parceiro</h5>
              <h2 className="title">Indicar minha empresa</h2>
            </div>
            <a href="/demo/simulacao" className="btn-access">Indicar</a>
          </div>
          <div className="option">
           <div className="header">
              <h5 className="subtitle">Já sou parceira</h5>
              <h2 className="title">Empresa</h2>
           </div>
            <a href="#" className="btn-access">Acessar</a>
          </div>
          <div className="option">
            <div className="header">
              <h5 className="subtitle">Já sou cadastrado</h5>
              <h2 className="title">Colaborador</h2>
            </div>
            <a href="#" className="btn-access">Acessar</a>
          </div>
        </div>
      </div>
    </div>
  )
}